import { useState } from 'react'
import { Modal, Checkbox, Popover, Layout, Switch, Button, Form, Input, notification } from 'antd'
import { DeleteOutlined, QuestionCircleOutlined, SaveOutlined } from '@ant-design/icons'
import { useHistory, useParams } from 'react-router-dom'
import Feather from '@sysunite/react-feather'
import './Entities.scss'

{ confirm } = Modal
{ Content } = Layout

export default ({ displayName, fields, onDelete, editActions = [], afterCreate, Extra }) -> ({ item, onUpdate }) ->

  [form] = Form.useForm()
  [requiredMark, setRequiredMarkType] = useState('optional')
  [disabled, setDisabled] = useState(false)
  [saving, setSaving] = useState(false)

  history = useHistory()
  { action } = useParams()
  additionalSaves = _.filter(fields(action), (field) -> field.onSave?)

  options = [
    {
      label: 'Clone data',
      value: 'data',
    },
    {
      label: 'Clone files',
      value: 'files',
    },
    {
      label: 'Clone pipelines config',
      value: 'pipelines-config',
    },
    # TODO WHEN POSSIBLE TO CLONE CONFIG BRANCH (ALWAYS CHECKED AND DISABLED)
    # {
    #   label: 'Clone project config',
    #   value: 'project-config',
    # },
  ];

  cloneOpts =
    <Form.Item
      name="options"
      label="Options"
      required={true}
    >
      <Checkbox.Group
        style={{ display: 'flex', flexDirection: 'column' }}
        options={options}
        onChange={(vals) ->
          if vals.length is 0 then setDisabled(true) else setDisabled(false)
        }
      />
    </Form.Item>

  clone = (values) ->
    { options } = values
    serverCloneOpts = { data: options.includes('data'), files: options.includes('files') }
    pipelinesCloneOpts = options.includes('pipelines-config')
    targetProject = new Weaver.Project(values['_name'], values.cloneId)
    cloned = undefined
    if (serverCloneOpts.data or serverCloneOpts.files)
      cloned = await item.clone(values.cloneId, values['_name'], serverCloneOpts)
    else
      cloned = await targetProject.save()
    if pipelinesCloneOpts
      orchestrator = await Weaver.Plugin.load('weaver-orchestrator')
      await orchestrator.clone({ sourceProject: values['_id'], targetProject: targetProject.id() })
    cloned

  onRequiredTypeChange = ({ requiredMark }) ->
    setRequiredMarkType(requiredMark)

  actionFn = (values) ->
    _.map(values, (val, key) -> if key isnt 'options' then item[key] = val)
    if action is 'clone'
      try
        clonedItem = await clone(values)
        await afterCreate(clonedItem) if afterCreate?
        history.push("/acl/spaces/#{clonedItem.id()}")
      catch e
        notification.error({
          message: "Error"
          description: e.message
          duration: 8
        })
    else
      try
        if item.isCreating
          await item.create?() or item.save?()
          delete item.isCreating
          history.replace(
            history.location.pathname.replace('new', item.id())
          )
        else
          await item.rename?(item.name())
          await item.save()
          onUpdate(Object.setPrototypeOf({
            item...
          }, Object.getPrototypeOf(item)))

        await Promise.map(additionalSaves, ({ field, onSave }) ->
          onSave(item, values[field])
        )

        await afterCreate(item) if afterCreate?
      catch e
        notification.error({
          message: "Error"
          description: e.message
          duration: 8
        })

  <Content style={{ padding: 16 }}>
    <Form
      form={form}
      layout="vertical"
      initialValues={{ requiredMark, options: ['data', 'files', 'pipelines-config'] }}
      onValuesChange={onRequiredTypeChange}
      requiredMark={requiredMark}
      onFinish={(values) ->
        setSaving(true)
        await actionFn(values)
        setSaving(false)
      }
    >
      {fields(action).filter(({ editable }) ->
        not (editable is 'hidden' and not item.isCreating)
      ).map((field) ->
        editable = true
        if typeof field is 'object'
          { field, initialValue, label, editable = true, info, Component } = field
        label ?= field
        Component ?= Input
        isBoolean = typeof item[field] is 'boolean'
        <Form.Item
          label={
            <>
              <span>{ _.capitalize(label) }</span>
              {
                if info?
                  <Popover content={info} placement="right">
                    <span style={{ marginLeft: '8px' }}><QuestionCircleOutlined /></span>
                  </Popover>
              }
            </>
          }
          initialValue={initialValue || item[field]}
          name={field}
          key={field}
          valuePropName={
            if isBoolean
              'checked'
            else
              'value'
          }
          data-testid="form-item-#{ field }"
          required
        >
          {if isBoolean
            <Switch
              defaultChecked={item[field]}
              disabled={not editable and not item.isCreating}
              onChange={(checked) ->
                form.setFieldsValue({ field: checked })
              }/>
          else
            <Component
              placeholder={_.capitalize(label)}
              disabled={not editable and not item.isCreating}
              onChange={({ target: { value }}) ->
                form.setFieldsValue({ field: value })
              }
            />
          }
        </Form.Item>
      )}
      {if Extra then <Extra item={item} />}
      {if action is 'clone' then cloneOpts}
      <Form.Item className="form-actions">
        <Button
          type="primary"
          loading={saving}
          htmlType="submit"
          data-testid="submit-form-btn"
          disabled={disabled}
          icon={<SaveOutlined />}
        >
          { if action? then _.startCase(action) else 'Save' }
        </Button>
        {
          if not item.isCreating and action isnt 'clone'
            editActions.map((Component, index) ->
              <Component item={item} key={index} />
            )
        }
        {
          if (not item.isCreating and onDelete?) and action isnt 'clone'
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
              onClick={->
                name = displayName(item)
                Modal.confirm({
                  title: <span>You are about to delete <b>{name}</b></span>,
                  content: <span>Are you sure you want to delete <b>{name}</b>?</span>,
                  icon: <span className="anticon"><Feather type="alert-circle" /></span>
                  okText: 'Yes',
                  okType: 'danger',
                  cancelText: 'No',
                  onOk: ->
                    onDelete({ history, item })
                })
              } />
        }
      </Form.Item>
    </Form>
  </Content>
